import { NewMessageModalDetails } from "./MessageAssistant";

export const DashboardAssistant = {
    "Dashboard": {
        items: [
            //Viewing your messages on your dashboard
            {
                heading: 'Viewing your messages on your dashboard',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'showing', 'message', 'dashboard', 'messages'],
                sections: [
                    {
                        description: 'Go to your dashboard',
                        styleAs: 'list',
                    },
                    {
                        description: 'Under the dashboard card, select the day you would like to view your messages for',
                        styleAs: 'list',
                        ref: {
                            ref: 'DashboardMessagesGroupBreakDown',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'Your messages will updated by the system and a breakdown of your messages will be shown on the messages section',
                        styleAs: 'list',
                        ref: {
                            ref: 'DashboardMessagesGroupMessages',
                            action: 'highlight'
                        }
                    },
                    {
                        description: 'To view the message, select the <b>Show Message</b> button on the appropriate line item',
                        styleAs: 'list',
                    }
                ],
                options: [
                    {
                        option: 'Take me to my dashboard',
                        action: {
                            type: 'location',
                            value: '/Dashboard',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Sending a new message from your dashboard
            {
                heading: 'Sending a new message from your dashboard',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'create', 'start', 'send', 'sending', 'message', 'dashboard', 'messages'],
                sections: [
                    {
                        description: 'Go to your dashboard',
                        styleAs: 'list',
                    },
                    {
                        description: 'Under the dashboard card, select the <b>Start a new message</b> button',
                        styleAs: 'list',
                    },
                    {
                        description: 'This will open the message sending modal',
                        styleAs: 'note',
                    },
                    ...NewMessageModalDetails
                ],
                options: [
                    {
                        option: 'Take me to my dashboard',
                        action: {
                            type: 'location',
                            value: '/Dashboard',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Linking a message to an event from your dashboard
            {
                heading: 'Linking a message to an event from your dashboard',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'create', 'start', 'send', 'sending', 'message', 'dashboard', 'messages', 'event', 'task', 'notes', 'document'],
                sections: [
                    {
                        description: 'Go to your dashboard',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the message you would like to link to an event',
                        styleAs: 'list',
                        extra: {
                            type: 'Side Note',
                            section: {
                                type: 'sub-section',
                                humanReadable: 'More info',
                                module: 'Dashboard',
                                sectionName: 'Viewing your messages on your dashboard'
                            }
                        }
                    },
                    {
                        description: 'Click the links Tab',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select <b>Link message to event</b>',
                        styleAs: 'list',
                    },
                    {
                        description: 'Search for the person the event happened to ',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the event',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select link on the bottom of the modal',
                        styleAs: 'list',
                    },
                    {
                        description: 'A toast message will popup to confirm the message has been linked as well as the linked list will automatically be updated',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my dashboard',
                        action: {
                            type: 'location',
                            value: '/Dashboard',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
            //Viewing your calendar on the dashboard
            {
                heading: 'Viewing your calendar on the dashboard',
                permissions: ['Clinician', 'Clinical User', 'Admin', 'Office Admin', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance', 'Patient', 'Client', 'Super', 'Facility Manager', 'Technical Support', 'System Admin', 'DrData Tech', 'DrData Sales', 'DrData Compliance'],
                tags: ['messaging', 'create', 'start', 'send', 'sending', 'message', 'dashboard', 'messages', 'event', 'task', 'notes', 'document'],
                sections: [
                    {
                        description: 'Navigate to your dashboard',
                        styleAs: 'list',
                    },
                    {
                        description: 'Under the dashboard card, you will find a breakdown of your calendar for the next 7 days',
                        styleAs: 'list',
                    },
                    {
                        description: 'Each line item will show you a breakdown by event status',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to my dashboard',
                        action: {
                            type: 'location',
                            value: '/Dashboard',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}